import { render, staticRenderFns } from "./bidding-result.vue?vue&type=template&id=0ca7ca53&scoped=true"
import script from "./bidding-result.vue?vue&type=script&lang=js"
export * from "./bidding-result.vue?vue&type=script&lang=js"
import style0 from "./bidding-result.vue?vue&type=style&index=0&id=0ca7ca53&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca7ca53",
  null
  
)

export default component.exports